(function (angular) {
	angular.module('bizPartEngage').directive('bizSearch', bizSearchDirective);
	angular.module('bizPartEngage').service('bizSearchService', bizSearchService);

	bizSearchDirective.$inject = ["bizCore"];
	bizSearchService.$inject = ["$state"];

    function bizSearchDirective(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: {
            	ReferrerType: "@referrerType",
				ReferrerId: "@referrerId",
                Expand: "=?expand",
                ExplicitIndexList: "@explicitIndexList",
                Source: "@source",
            },
            templateUrl: function (element, attr) {
                if (attr.templateurl) {
                    return siteRootPath + attr.templateurl;
                } else {
                    return bizCoreProvider.getView('core.directives.search', "FrontEnd/Core/Directives/Views/Search.html")
                }
            },
            controller: bizSearchController,
            controllerAs: "vm",
            bindToController: true
        }

        bizSearchController.$inject = ["core.users.service", "bizCoreService", "bizSearchService", "$state", "$rootScope"];

        function bizSearchController(userService, bizCoreService, bizSearchService, $state, $rootScope) {
        	    var vm = this;
		    vm.MaxHits = 20;
            vm.CanSearch = true;

        	    vm.Search = Search;        	
        	    vm.GoToResult = GoToResult;
            vm.GoToResults = GoToResults;
            vm.ClearForm = ClearForm;
            vm.GoToResults = GoToResults;
            vm.GetCustomValue = GetCustomValue;

            vm.HitsIncement = 4;

            function ClearForm() {
                vm.SearchText = '';
                vm.Expand = false;
                vm.Results = null;
            }

        	    function GoToResults() {
        		    vm.Expand = false;

        		    if (!vm.SearchText)
        			    return;

        		    $state.go('base.modules.search', { query: vm.SearchText});
        	    }

            function Search() {
                if (!vm.SearchText || vm.SearchText.length < bizSearchService.MinSearchTermLength || !vm.CanSearch)
        		    return;

                vm.SearchIndexList = null;

        		    vm.SearchIndexList = [
                        { Index: 2, SearchIndexExternalName: "Page", TotalHits: vm.HitsIncement, CustomFilters: [] },
                        { Index: 3, SearchIndexExternalName: "Blog", TotalHits: vm.HitsIncement, CustomFilters: [] },
                        { Index: 4, SearchIndexExternalName: "Dictionary", TotalHits: vm.HitsIncement, CustomFilters: [] },
                        { Index: 5, SearchIndexExternalName: "Video", TotalHits: vm.HitsIncement, CustomFilters: [] },
                        { Index: 6, SearchIndexExternalName: "Educations", TotalHits: vm.HitsIncement, CustomFilters: [] },
                        { Index: 15, SearchIndexExternalName: "Event", TotalHits: vm.HitsIncement, CustomFilters: [] },
                    ];
				
				vm.CanSearch = false;
				setTimeout(function(vm) {
					vm.CanSearch = true;
                }, 500, vm);

                return bizCoreService.Search(vm.SearchText, vm.MaxHits, vm.ReferrerType, vm.ReferrerId, [], vm.SearchInIndexes).then(SearchCallback);

            	function SearchCallback(response) {
            		var results = BizPartCoreHelpers.getResponseValue(response, {});

            		for (var i = 0; i < results.IndexList.length; i++) {
            		    results.IndexList[i].Items = results.ResultItems.GetItemsByValue('Index', results.IndexList[i].Index);
            		}

                if (vm.ExplicitIndexNumbers && vm.ExplicitIndexNumbers.length > 0)
                    results.IndexList = results.IndexList.filter(r => vm.ExplicitIndexNumbers.includes(r.Index))

                if (typeof GetSearchResultCallbackFn === 'function') {
                    results = GetSearchResultCallbackFn(results, vm.Source, $rootScope);
                }

                vm.Results = results;
            		vm.Expand = true;
            	}
        	}

            function GetCustomValue(item, key) {
                var customValue = item.CustomValues.GetItemsByValue('Key', key);

                if (customValue != null && customValue.length == 1) {
                    return customValue[0].Value;
                }

                return '';
            }

            function GoToResult(item) {
                vm.Expand = false;
                bizCoreService.LogSearch(item);
                const itemUrl = bizSearchService.GetItemUrl(item);

                if (itemUrl)
                    window.location.assign(itemUrl);
            }

            function Init() {
                vm.SearchIndexList = [
                    { Index: 2, SearchIndexExternalName: "Page", TotalHits: vm.HitsIncement },
                    { Index: 3, SearchIndexExternalName: "Blog", TotalHits: vm.HitsIncement },
                    { Index: 4, SearchIndexExternalName: "Dictionary", TotalHits: vm.HitsIncement },
                    { Index: 5, SearchIndexExternalName: "Video", TotalHits: vm.HitsIncement },
                    { Index: 6, SearchIndexExternalName: "Educations", TotalHits: vm.HitsIncement },
                    { Index: 15, SearchIndexExternalName: "Event", TotalHits: vm.HitsIncement },
                ];

                vm.SearchInIndexes = vm.SearchIndexList;
                if (vm.ExplicitIndexList) {
                    vm.ExplicitIndexNumbers = vm.ExplicitIndexList.split(',').map(s => parseInt(s.trim(), 10));
                    vm.SearchInIndexes = vm.SearchIndexList.filter(si => vm.SearchIndexList.some(e => vm.ExplicitIndexNumbers.includes(si.Index)));
                }
            }
			
			this.$onInit = Init;
        }

        return directive;
    }

    function bizSearchService($state) {
        this.MinSearchTermLength = 3;
        this.CustomIndexUrls = {};

        this.GetItemUrl = function (item) {
            if (typeof GetSearchResultItemUrlFn === 'function') {
                return GetSearchResultItemUrlFn(item, $state);
            }

            if (item.State == 'base.modules.educations') {
                // temphack for scorm
                return url = $state.href(item.State);
            }

    		    var url = $state.href(item.State, JSON.parse(item.StateParameters));

    		    if (!this.CustomIndexUrls[item.SearchIndexExternalName])
    			    return url;

    		    for (var i = 0; i < this.CustomIndexUrls[item.SearchIndexExternalName].length; i++) {
    			    if (this.CustomIndexUrls[item.SearchIndexExternalName][i].ItemIds.indexOf(item.ItemId) > -1) {
    				    return $state.href(this.CustomIndexUrls[item.SearchIndexExternalName][i].State, this.CustomIndexUrls[item.SearchIndexExternalName][i].StateParams)
						    + this.CustomIndexUrls[item.SearchIndexExternalName][i].Query.replace("#ITEMID#", item.ItemId);
    			    }
    		    }

    		    return url;
        }
    }
})(window.angular);
